import { render, staticRenderFns } from "./settingNotification.vue?vue&type=template&id=2184fcb5&"
import script from "./settingNotification.vue?vue&type=script&lang=js&"
export * from "./settingNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports